import * as React from "react"
import { TouchableOpacity, Pressable } from "~/ui/primitives"
import { Text } from "../text/text"
import { viewPresets, textPresets } from "./button.presets"
import { ButtonProps } from "./button.props"
import styled from '~/ui/styled'
import Icon from "~widgets/icon"
/**
 * For your text displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */

export function Button(props: ButtonProps) {
  // grab the props
  const {
    preset = "primary",
    tx,
    text,
    style: styleOverride,
    textStyle: textStyleOverride,
    children,
    ...rest
  } = props

  const viewStyle = viewPresets[preset] || viewPresets.primary
  const viewStyles = [viewStyle, styleOverride]
  const textStyle = textPresets[preset] || textPresets.primary
  const textStyles = [textStyle, textStyleOverride]
  const content = children || <Text tx={tx} text={text} style={textStyles} />
  return (
    <TouchableOpacity style={viewStyles} {...rest}>
      {content}
    </TouchableOpacity>
  )
}
const BlockButtonWrap = styled.TouchableOpacity`
  width: 100%;
  padding: 20px;
  align-items: center;
  background-color: ${({ theme, type }: { theme: any; type: any }) =>
    type === "primary" ? theme.colors.primary : "white"};
`
const BlockButtonText = styled.Text`
  color: ${({ type, theme }: { theme: any; type: any }) =>
    type === "primary" ? "white" : type === "danger" ? "#dd3333" : theme.colors.primary};
  font-size: 16px;
`
export const BlockButton = ({ onClick, text, type = "light", ...rest }) => {
  return (
    <BlockButtonWrap onClick={onClick} type={type} {...rest}>
      <BlockButtonText type={type}>{text}</BlockButtonText>
    </BlockButtonWrap>
  )
}

export const TextButton = ({ onClick, children, disabled = false, textColor = "#121212" }) => {
  const Span = styled.Text`
    color: ${({ disabled }) => (disabled ? "#999" : textColor || "#121212")};
  `
  return (
    <Pressable
      onClick={(e) => {
        disabled || (onClick && onClick(e))
      }}
    >
      <Span disabled={disabled}>{children}</Span>
    </Pressable>
  )
}

export const NormalButton = ({
  type = "primary",
  disabled = false,
  text = "",
  onClick,
  children = null,
  style: overrideStyle = {},
}) => {
  const style = {
    alignSelf: "flex-start",
    ...(disabled && { backgroundColor: "#f5f5f5" }),
    ...overrideStyle,
  }
  const textStyle = {
    ...(disabled && { color: "#999" }),
  }
  return (
    <Button
      onClick={() => onClick && !disabled && onClick()}
      preset={type}
      style={style}
      text={text}
      textStyle={textStyle}
    >
      {children}
    </Button>
  )
}

export const HeaderIconButton = ({ iconName, iconColor = "#121212", iconSize, onClick }) => {
  return (
    <Pressable
      onClick={(e) => {
        onClick && onClick(e)
      }}
    >
      <Icon name={iconName} color={iconColor || "#121212"} size={iconSize || 20} />
    </Pressable>
  )
}
